import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Button from '@material-ui/core/Button';

import 'react-datepicker/dist/react-datepicker.css';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

const CardCancelSummaryModel = ({
  modalIsOpen,
  closeModal,
  serialNumber,
  navigateToIssuedCardTable,
  handleReplaceCardBtn
}) => {
  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Card Modal"
        className="modal"
        overlayClassName="overlay"
      >
        <div>
          <div className="close-icon">
            <CloseOutlinedIcon
              style={{ color: '#FFFB00' }}
              size="20px"
              onClick={closeModal}
            />
          </div>
          <div className="card-cancelled-summary-header">Card Cancelled</div>
          <div className="card-cancelled-summary-text">
            Card Serial number {serialNumber} has been cancelled.
          </div>
          <div className="button-container">
            <Button
              variant="outlined"
              color="primary"
              onClick={navigateToIssuedCardTable}
            >
              Back To Issued Card Table
            </Button>

            <Button
              variant="outlined"
              color="primary"
              onClick={handleReplaceCardBtn}
            >
              Replace Card
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

CardCancelSummaryModel.propTypes = {
  selectedCard: PropTypes.object,
  serialNumber: PropTypes.string,
  modalIsOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  handleReplaceCardBtn: PropTypes.func,
  navigateToIssuedCardTable: PropTypes.func
};

export default CardCancelSummaryModel;
